/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cognito_identity_pool_id": "eu-west-3:76cd77e3-9429-47b2-970a-7bcf1e4a265c",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_15byw5uGw",
    "aws_user_pools_web_client_id": "7h9kt68ooilj0be3ibirli9vf",
    "oauth": {
         domain: 'beonwalldev.auth.eu-west-3.amazoncognito.com',
         scope: ['email', 'openid', 'profile'],
         redirectSignIn: 'http://localhost:3000/login,https://staging.d3kpith7jlunmd.amplifyapp.com/login,www.dev.beonwall.com/login',
         redirectSignOut: 'http://localhost:3000/login,https://staging.d3kpith7jlunmd.amplifyapp.com/login,www.dev.beonwall.com/login',
         responseType: 'code'
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
